import * as React from "react";
import {
  IconReactionChefsKiss,
  IconReactionMindBlowing,
  IconReactionMustHug2,
  IconReactionNeedItNow,
  IconReactionObsessed,
  IconReactionOutOfThisWorld,
  IconReactionTakeMyMoney,
  IconReactionThoughtProvoking,
} from "atoms";
import { useArtist } from "features/reviewable/api/useArtist";
import { ReviewStats } from "./ReviewStats";

interface Props {
  artistId: string;
}

function ArtistReviewStats({ artistId, ...props }: Props) {
  const { data: artist } = useArtist(artistId);

  const ratings = React.useMemo(() => {
    const aggregateRatings = {
      "Must Hug": {
        value: artist?.counterMustHug ?? 0,
        icon: <IconReactionMustHug2 aria-label="hidden" />,
      },
      "Chef's kiss": {
        value: artist?.counterChefsKiss ?? 0,
        icon: <IconReactionChefsKiss aria-label="hidden" />,
      },
      "Mind-blowing": {
        value: artist?.counterMindBlowing ?? 0,
        icon: <IconReactionMindBlowing aria-label="hidden" />,
      },
      "Need it now": {
        value: artist?.counterNeedItNow ?? 0,
        icon: <IconReactionNeedItNow aria-label="hidden" />,
      },
      Obsessed: {
        value: artist?.counterObsessed ?? 0,
        icon: <IconReactionObsessed aria-label="hidden" />,
      },
      "Out of this world": {
        value: artist?.counterOutOfThisWorld ?? 0,
        icon: <IconReactionOutOfThisWorld aria-label="hidden" />,
      },
      "Take my money": {
        value: artist?.counterTakeMyMoney ?? 0,
        icon: <IconReactionTakeMyMoney aria-label="hidden" />,
      },
      "Thought-provoking": {
        value: artist?.counterThoughtProvoking ?? 0,
        icon: <IconReactionThoughtProvoking aria-label="hidden" />,
      },
    };

    return aggregateRatings;
  }, [artist]);

  return (
    <ReviewStats
      type="ARTIST"
      ratings={ratings}
      max={artist?.reviewCount}
      {...props}
    />
  );
}

export { ArtistReviewStats };
